// gown-builder-swatches.js
window.PaperDolls = window.PaperDolls || {};
window.PaperDolls.swatches = window.PaperDolls.swatches || {};

console.log('Paper Dolls: swatches module loaded');

const BUILDER_COLOR_HEX = {
  'Black': '#000000',
  'Hunter': '#044b33',
  'Emerald': '#046b3c',
  'Sapphire': '#0a2b7c',
  'Scarlet': '#c0132b',
  'Ruby': '#8b0014',
  'Garnet': '#6b0010',
  'Blush': '#d7a6a0',
  'Smoke': '#aaaaaf',
  'Ivory': '#f6f2ec',
  // add more as you standardize names
};

function lookupHex(colorName) {
  if (!colorName) return null;

  // direct match first (your existing keys)
  if (BUILDER_COLOR_HEX[colorName]) {
    return BUILDER_COLOR_HEX[colorName];
  }

  const lower = colorName.toLowerCase();

  // forgiving match: ignore case
  for (const key in BUILDER_COLOR_HEX) {
    if (!Object.prototype.hasOwnProperty.call(BUILDER_COLOR_HEX, key)) continue;
    if (key.toLowerCase() === lower) {
      return BUILDER_COLOR_HEX[key];
    }
  }
  return null;
}

const BUILDER_SWATCH_DEFAULT_MAX = 5;

// Build one swatch dot (now aware of variant metafields)
function createBuilderSwatch(colorName, variantId) {
  const swatch = document.createElement('button');
  swatch.type = 'button';
  swatch.className = 'builder26-swatch';
  swatch.dataset.color = colorName;

  // Try variantSwatches map built in Liquid
  const swatchMeta =
    (window.variantSwatches && window.variantSwatches[variantId]) || null;

  if (swatchMeta && swatchMeta.image) {
    // Image swatch (glitter, print, watercolor, etc.)
    swatch.style.backgroundImage = `url('${swatchMeta.image}')`;
    swatch.style.backgroundSize = 'cover';
    swatch.style.backgroundPosition = 'center';
      // 🔑 critical: prevent the color-dot CSS from painting over image swatches
  swatch.style.backgroundColor = 'transparent';
  swatch.style.removeProperty('--builder26-swatch-color');
  swatch.classList.add('builder26-swatch--image');
  } else if (swatchMeta && swatchMeta.color) {
    // Solid color from metafield
    swatch.style.setProperty('--builder26-swatch-color', swatchMeta.color);
  } else {
    // Fallback: use name → hex, then a safe neutral if still unknown
    const hex = lookupHex(colorName);
    if (hex) {
      swatch.style.setProperty('--builder26-swatch-color', hex);
    } else {
      // nothing in map, but don't leave it “empty white”
      swatch.style.setProperty('--builder26-swatch-color', '#f2eee8');
      swatch.style.borderStyle = 'dashed';
    }
  }

  const label = document.createElement('span');
  label.className = 'builder26-swatch-label';
  label.textContent = colorName;
  swatch.appendChild(label);

  // For now, just log. Later we’ll wire this to filter variants by color.
  swatch.addEventListener('click', (event) => {
    event.stopPropagation();
    console.log('Swatch clicked:', colorName, 'variant', variantId);
    // TODO: openProductVariantsWithColorFilter(productHandle, colorName)
  });

  return swatch;
}


// Public API the core file calls
window.PaperDolls.swatches.renderProductSwatches = function renderProductSwatches(product, cardElement) {
  if (!product || !cardElement) return;

  const wrap = cardElement.querySelector('[data-builder-swatch-wrap]');
  const row  = cardElement.querySelector('[data-builder-swatch-row]');
  if (!wrap || !row) return;

  // Clear previous dots / expander in case of re-render
  row.innerHTML = '';
  const oldExpander = wrap.querySelector('.builder26-swatch-expander');
  if (oldExpander) oldExpander.remove();

  const maxVisible = parseInt(
    wrap.getAttribute('data-builder-max-swatches') || BUILDER_SWATCH_DEFAULT_MAX,
    10
  );

// Use first variant for each color as representative
const seen = new Set();
const colorEntries = [];

// Start from visible variants if available
let variantsList = (product.variants || []);

if (
  window.PaperDolls &&
  window.PaperDolls.variants &&
  typeof window.PaperDolls.variants.getVisibleVariants === 'function'
) {
  variantsList = window.PaperDolls.variants.getVisibleVariants(product);
}

// Build ONE entry per color (deduped)
variantsList.forEach((variant) => {
  const rawColor = variant.option2; // adjust ONLY if color is option1/3
  const colorName = (rawColor || '').trim();
  if (!colorName) return;

  const key = colorName.toLowerCase();
  if (seen.has(key)) return;
  seen.add(key);

  colorEntries.push({
    colorName,
    variantId: variant.id
  });
});

if (!colorEntries.length) {
  wrap.style.display = 'none';
  return;
} else {
  wrap.style.display = 'flex';
}

const visibleColors = colorEntries.slice(0, maxVisible);
const hiddenColors  = colorEntries.slice(maxVisible);

// Visible dots
visibleColors.forEach(entry => {
  const swatch = createBuilderSwatch(entry.colorName, entry.variantId);
  row.appendChild(swatch);
});

// Hidden dots
hiddenColors.forEach(entry => {
  const swatch = createBuilderSwatch(entry.colorName, entry.variantId);
  swatch.classList.add('builder26-swatch--hidden');
  row.appendChild(swatch);
});

// "+ more" pill (no number anymore, to avoid clutter)
if (hiddenColors.length) {
  const expander = document.createElement('button');
  expander.type = 'button';
  expander.className = 'builder26-swatch-expander';
  expander.dataset.builderSwatchMore = 'true';
  expander.setAttribute('aria-expanded', 'false');
  expander.textContent = '+ more';

  expander.addEventListener('click', (event) => {
    event.stopPropagation();
    const expanded = wrap.classList.toggle('builder26-swatch-wrap--expanded');
    expander.setAttribute('aria-expanded', String(expanded));
    expander.textContent = expanded ? 'Show less' : '+ more';
  });

  wrap.appendChild(expander);
}

};
